// extracted by mini-css-extract-plugin
module.exports = {"bg":"aQnzN","inlineContent":"_3pLKE","pageWrapper":"_1HEfv","innerBg":"_233_l"};